module.exports = __webpack_public_path__ + "img/big4-13.005a736a.jpg";